import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-union",
  "use": "icon-union-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-union\"><g fill-rule=\"evenodd\"><path fill=\"#b5bac0\" d=\"M6 12h14v14H6z\" /><path d=\"M14 4a4 4 0 0 0-4 4v2H8a4 4 0 0 0-3.995 3.8L4 14v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-2h2a4 4 0 0 0 3.995-3.8L28 18V8a4 4 0 0 0-4-4Zm-6 8h2v6a4 4 0 0 0 3.8 3.995L14 22h6v2a2 2 0 0 1-1.85 1.995L18 26H8a2 2 0 0 1-2-2V14a2 2 0 0 1 2-2\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol